import Vue from "vue";
import Vuex from "vuex";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import vSelect from "vue-select";
import { BootstrapVue } from "bootstrap-vue";
import vueSmoothScroll from 'vue2-smooth-scroll';
import VueClipboard from 'vue-clipboard2';
import datePicker from 'vue-bootstrap-datetimepicker';
import VueTheMask from 'vue-the-mask';
import * as TastyBurgerButton from 'vue-tasty-burgers';
import AxiosPlugin from 'vue-axios-cors';
// import DatePicker from 'vue2-datepicker';
// import { VuejsDatatableFactory } from 'vuejs-datatable';
// import vHamburgers from "vue-hamburgers";

import "vue-select/dist/vue-select.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import 'vue2-datepicker/index.css';

Vue.config.productionTip = false;

Vue.component("v-select", vSelect);
Vue.use(Vuex);
Vue.use(BootstrapVue);
Vue.use(vueSmoothScroll);
Vue.use(VueClipboard);
Vue.use(datePicker);
// Vue.use(DatePicker);
Vue.use(VueTheMask);
Vue.use(TastyBurgerButton);
Vue.use(AxiosPlugin);
// Vue.use(vHamburgers);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
